import {
  TOGGLE_REDESIGN,
} from './actionTypes';

export default function reducer(state = false, action) {
  switch (action.type) {
    case TOGGLE_REDESIGN:
      return action.isRedesign;
    default:
      return state;
  }
}


export function toggleRedesign(isRedesign) {
  return {
    type: TOGGLE_REDESIGN,
    isRedesign,
  };
}
